import get from 'lodash/get';

interface IObjectProjectsKeys {
    [key: string]: string;
  }

interface Projects extends IObjectProjectsKeys {
    'Rp': string;
    'RpTvaReduite': string;
    'RpBrs': string;
    'Dp': string;
    'IrgJb': string;
    'Ai': string;
  }

const projects: Projects = {
    'Rp': 'Résidence principale (TVA 20%)',
    'RpTvaReduite': 'Résidence principale éligible TVA réduite',
    'RpBrs': 'Résidence principale éligible BRS',
    'Dp': 'Invest Jean Brun/LLI',
    'IrgJb': 'Invest régime général/Jean Brun',
    'Ai': 'Autre investissement',
};



function formatProjects(value: string) {
    return get(projects, value, value);
}

export { projects, formatProjects };


